export const inProgress = (navigate) => navigate('/in-progress')

export const getUtmParams = (fallbackUser = {}) => ({
  utm_source: localStorage.getItem('utm_source') || fallbackUser.utm_source || '',
  utm_medium: localStorage.getItem('utm_medium') || fallbackUser.utm_medium || '',
  utm_campaign: localStorage.getItem('utm_campaign') || fallbackUser.utm_campaign || ''
})
